/** Nested drawers / overlays: only clear body overflow when the last lock is released. */
let bodyScrollLockDepth = 0;
/** Scroll position at the moment of the first lock, restored on the last unlock. */
let lockedScrollY = 0;

/**
 * This function will helps to lock the body element.
 * Safe to call from stacked drawers — overflow stays hidden until matching unlocks.
 * `position: fixed` on body resets the visual scroll to 0, so the current scroll position is
 * captured on the first lock (only) and re-applied as a negative `top` to hold the page in place.
 */
export const lockBody = () => {
  if (typeof document === "undefined") {
    return;
  }
  if (bodyScrollLockDepth === 0) {
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = `-${lockedScrollY}px`;
  }
  bodyScrollLockDepth += 1;
  document.body.style.overflow = "hidden";
  document.body.style.position = "fixed";
  document.body.style.width = "100%";
};

/**
 * Scroll offset that should drive sticky header/banner layout.
 * While the body is locked, `window.scrollY` is 0 because `position: fixed` resets it.
 * The real offset is the one captured in `lockBody`.
 * @returns {number}
 */
export const getDocumentScrollY = () => {
  if (typeof window === "undefined") {
    return 0;
  }
  if (bodyScrollLockDepth > 0) {
    return lockedScrollY;
  }
  return window.scrollY || window.pageYOffset || 0;
};

/**
 * This function will helps to unlock the body element.
 * Decrements the lock depth; removes overflow only when no locks remain, and scrolls back to
 * where the page was before the first lock (position:fixed otherwise leaves it at the top).
 */
export const unlockBody = () => {
  if (typeof document === "undefined") {
    return;
  }
  bodyScrollLockDepth = Math.max(0, bodyScrollLockDepth - 1);
  if (bodyScrollLockDepth === 0) {
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("position");
    document.body.style.removeProperty("width");
    document.body.style.removeProperty("top");
    window.scrollTo(0, lockedScrollY);
  }
};

/**
 * This function will helps to hide the footer and long description element.
 */
export const hideElementsForPLP = () => {
  if (document.getElementById("footer")) {
    document.getElementById("footer").style.cssText = "display:none !important";
  }
  if (document.getElementById("longDescription")) {
    document.getElementById("longDescription").style.display = "none";
  }
};

/**
 * This function will helps to show the footer and long description element.
 */
export const showElementsForPLP = () => {
  if (document.getElementById("footer")) {
    document.getElementById("footer").style.cssText = "display:flex !important";
  }
  if (document.getElementById("longDescription")) {
    document.getElementById("longDescription").style.display = "block";
  }
};
